module.exports = __webpack_public_path__ + "static/media/image 29-1.bc8d7cc2.svg";